module.exports = {"private":true,"main":"./ApplicationIDSecretInfoModal.js"}


//////////////////
// WEBPACK FOOTER
// ./app/javascript/components/frags/ApplicationIDSecretInfoModal/package.json
// module id = 841
// module chunks = 0 1